import CustomTooltip from "./tooltip";
import {
  orderDetailsWithPaginationUrl,
  releaseOrderUrl,
  updatePoReadyUrl,
} from "./constants";
import NotforwarderReady from "./Resources/NotforwarderReady.png";
import ForwarderReady from "./Resources/ForwarderReady.png";
import ForwarderProcessed from "./Resources/ForwarderProcessed.png";
import POReady from "./Resources/POReady.png";
import NotPOReady from "./Resources/NotPOReady.png";
import POProcessed from "./Resources/POProcessed.png";
import { getAccessToken } from "../utils/okta-config";
import { API_ROOT } from "../constants/constants";
import { toast } from "react-toastify";

export async function getOrderDetails(selectedLocation, pageNumber, pageSize) {
  const filterData = {
    locationId: selectedLocation,
    startOffset: pageNumber,
    dataLimitCount: pageSize,
  };
  const response = await fetch(orderDetailsWithPaginationUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
    },
    body: JSON.stringify(filterData),
  });
  const result = await response.json();

  result.content.map((a) => {
    //set icon for forwarder
    if (a.frwdNtfReady === "NO" && a.frwdNtfReady) {
      a.frwdNtfReady = CustomTooltip("Not forwarder Ready", NotforwarderReady);
    } else if (a.frwdNtfReady === "YES" && a.frwdNtfReady) {
      a.frwdNtfReady = CustomTooltip("Forwarder Ready", ForwarderReady);
    } else if (a.frwdNtfReady === "PRO" && a.frwdNtfReady) {
      a.frwdNtfReady = CustomTooltip("Forwarder Processed", ForwarderProcessed);
    }

    //set icon for PO
    if (a.poReady === "YES" && a.poReady) {
      a.poReady = CustomTooltip("PO Ready", POReady);
    } else if (a.poReady === "NO" && a.frwdNtfReady) {
      a.poReady = CustomTooltip("Not PO Ready", NotPOReady);
    } else if (a.poReady === "PRO" && a.frwdNtfReady) {
      a.poReady = CustomTooltip("PO Processed", POProcessed);
    }
  });

  return result.content;
}

export async function releaseOrder(orderPathId, getTableData) {
  const reqObj = {
    orderPathId: orderPathId,
  };
  const requestOptions = {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(reqObj),
  };

  fetch(releaseOrderUrl, requestOptions).then((response) => {
    if (response["status"] === 200) {
      getTableData();
      toast.success("Forward Notification Ready flag updated successfully");
    } else {
      toast.error("Forward Notification Ready flag updation failed");
    }
  });
}

export async function updatePoReady(orderPathId, getTableData) {
  const reqObj = {
    orderPathId: orderPathId,
  };
  const requestOptions = {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(reqObj),
  };

  fetch(updatePoReadyUrl, requestOptions).then((response) => {
    if (response["status"] === 200) {
      getTableData();
      toast.success("PO Ready flag updated successfully");
    } else {
      alert("PO Ready flag updation failed");
    }
  });
}
